import(/* webpackMode: "eager" */ "/home/runner/work/play/play/apps/play-portal/src/app/(root)/referral/page.tsx");
